import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import axiosInstance from "../../../lib/axios";
import {
  Box, Grid, Button, TextField, Typography, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, FormControl, InputLabel,
  Select, MenuItem, Autocomplete, FormHelperText, Checkbox
} from "@mui/material";
import {
  Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon,
} from "@mui/icons-material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UnLock from "../../../GlobalFunction/UnLock";
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { getRoomMasterdropdata } from '../../../Api/PropertyMst/Api'
import CustomAutocomplete from "../../AutoComplete/AutocompletewithoutIcon";

const StoreStep2 = ({
  TableData, mode, Cities, setTableData, AllfieldStepperData, IsuId,
  setActiveStep, fetchGoodsData, viewModeDis, addModeDis, setFlag,
  IsButtonSubmit, UserLoginId, TextDisabledFast
}) => {
  const { register, watch, reset, setValue, getValues } = useForm({
    defaultValues: {
      ItmCatId: "",
      ItmGrpId: "",
      ItmSubGrpId: "",
      ItmId: "",
      ItmQty: "",
      Rate: "0.00",
      ItmAmt: "0.00",
      UnitId: "",
      TagId: "",
      Remk: "",
      mode: 'onChange',
    }
  });

  console.log("Form", getValues());

  const userId = sessionStorage.getItem('UserId');
  const [AllTextDisabled, setAllTextDisabled] = useState(true);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(true);
  const [IndexofSelect, setIndexofSelect] = useState(-1);
  const [InternalMode, setInternalMode] = useState("add");
  const [AddDisabled, setAddDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [CategoryDrp, setCategoryDrp] = useState([]);
  const [categorySelected, setCategorySelected] = useState(false);
  const [ItmDrp, setItmDrp] = useState([]);
  const [GroupDrp, setGroupDrp] = useState([]);
  const [SubGrpdrp, setSubGrpdrp] = useState([]);
  const [Unitdrp, setUnitdrp] = useState([]);
  const divRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [columnFilters, setColumnFilters] = useState({});
  const [searchText, setSearchText] = useState("");
  const [propoption, setPropoption] = useState([])
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const columns = [
    { id: "ItmCatName", label: "Category", minWidth: 50 },
    { id: "ItmGrpName", label: "Group", minWidth: 40 },
    { id: "ItmSubGrpName", label: "SubGroup", minWidth: 40 },
    { id: "ItmName", label: "Item", minWidth: 200 },
    { id: "UnitName", label: "Unit", minWidth: 30 },
    { id: "ItmQty", label: "Qty", minWidth: 20 },
    { id: "Rate", label: "Rate", minWidth: 20 },
    { id: "ItmAmt", label: "Amount", minWidth: 20 },
  ];
  const filterTableData = (data) => {
    return data?.filter(row => {
      if (row.DBFLAG === "D") return false;
      return Object.keys(columnFilters).every(key => {
        if (!columnFilters[key]) return true;

        const cellValue = String(row[key] || "").toLowerCase();
        return cellValue.includes(columnFilters[key].toLowerCase());
      });
    });
  };

  const handleTagIdChange = (e) => {
    const value = e.target.value;
    // Validate to ensure only numeric values are allowed

    setValue("TagId", value);

  };

  useEffect(() => {
    fetchUnits();
    fetchCategoryData();
  }, []);

  const handlePropertyChange = (event, newValue) => {
    setSelectedProperty(newValue);
  };

  useEffect(() => {
    if (TableData?.length > 0 && IndexofSelect === -1) {
      setIndexofSelect(0);
    }
  }, [TableData]);

  useEffect(() => {
    if (TableData?.length > 0 && IndexofSelect >= 0) {
      const selectedRow = TableData[IndexofSelect];
      if (selectedRow) {
        if (AllTextDisabled) {
          setGroupDrp([]);
          setSubGrpdrp([]);
          setItmDrp([]);
          reset({
            ItmCatId: selectedRow.ItmCatId,
            ItmGrpId: selectedRow.ItmGrpId,
            ItmSubGrpId: selectedRow.ItmSubGrpId,
            ItmId: selectedRow.ItmId,
            TagId: selectedRow.TagId,
            ItmQty: selectedRow.ItmQty,
            Rate: selectedRow.Rate,
            ItmAmt: selectedRow.ItmAmt,
            UnitId: selectedRow.UnitId,
            Remk: selectedRow.Remk,
          });
          const populateDropdowns = async () => {
            try {
              const groupResponse = await axiosInstance.post(
                "MstItmGrp/GetMstItmGrpdrp",
                { ItmCatId: selectedRow.ItmCatId, Flag: "" }
              );
              if (groupResponse.data.Status === 0) {
                setGroupDrp(groupResponse.data.Data);

                const subGroupResponse = await axiosInstance.post(
                  "MstItmSubGrp/GetMstItmSubGrpdrp",
                  { ItmGrpId: selectedRow.ItmGrpId, Flag: "" }
                );
                if (subGroupResponse.data.Status === 0) {
                  setSubGrpdrp(subGroupResponse.data.Data);

                  const itemsResponse = await axiosInstance.post(
                    'MstItm/GetMstItmdrp',
                    { ItmSubGrpId: selectedRow.ItmSubGrpId }
                  );
                  if (itemsResponse.data.Status === 0) {
                    setItmDrp(itemsResponse.data.Data);
                  }
                }
              }
            } catch (error) {
              console.error("Error populating dropdowns:", error);
            }
          };
          populateDropdowns();
        }
      }
    }
  }, [IndexofSelect, TableData, AllTextDisabled, reset]);

  useEffect(() => {
    const quantity = parseFloat(watch("ItmQty")) || 0;
    const rate = parseFloat(watch("Rate")) || 0;
    setValue("ItmAmt", quantity * rate);
  }, [watch("ItmQty"), watch("Rate"), setValue]);

  const fetchCategoryData = async () => {
    try {
      const response = await axiosInstance.post(
        "MstItmCat/GetMstItmCatdrp",
        {}
      );
      if (response.data.Status === 0) setCategoryDrp(response.data.Data);
      else toast.error('Error fetching Category data');
    } catch (error) {
      toast.error('Error fetching Category data');
    }
  };

  const fetchUnits = async () => {
    try {
      const response = await axiosInstance.post(
        "MstUnit/getMstUnitdrp",
        {

        }
      );
      if (response.data.Status === 0) {
        setUnitdrp(response.data.Data);

      }
    } catch (error) {
      toast.error('Failed to load measurement units');
      console.log("Error getting while fetching unit from drp");
    }
  };

  const handleCategoryChange = async (e) => {
    setValue("ItmCatId", e.target.value);
    setCategorySelected(true);

    try {
      const response = await axiosInstance.post(
        "MstItmGrp/GetMstItmGrpdrp",
        {
          ItmCatId: e.target.value,
          Flag: ""
        }
      );
      if (response.data.Status === 0) {
        setGroupDrp(response.data.Data);
        if (response.data.Data.length > 0) {
          setValue("ItmGrpId", response.data.Data[0].ItmGrpId);
          handleGroupChange({ target: { value: response.data.Data[0].ItmGrpId } });
        }
      } else toast.error('Error fetching Group data');
    } catch (error) {
      toast.error('Error fetching Group data');
    }
  };

  const handleGroupChange = async (e) => {
    setValue("ItmGrpId", e.target.value);

    try {
      const response = await axiosInstance.post(
        "MstItmSubGrp/GetMstItmSubGrpdrp",
        {
          ItmGrpId: e.target.value,
          Flag: ""
        }
      );
      if (response.data.Status === 0) {
        setSubGrpdrp(response.data.Data);
        if (response.data.Data.length > 0) {
          setValue("ItmSubGrpId", response.data.Data[0].ItmSubGrpId);
          handleSubGrpChange({ target: { value: response.data.Data[0].ItmSubGrpId } });
        }
      } else toast.error('Error fetching Subgroup data');
    } catch (error) {
      toast.error('Error fetching Subgroup data');
    }
  };

  const handleSubGrpChange = async (e) => {
    setValue("ItmSubGrpId", e.target.value);
    try {
      const response = await axiosInstance.post(
        'MstItm/GetMstItmdrp',
        {
          ItmSubGrpId: e.target.value,
          Flag: 'ItmCat'
        }
      );
      if (response.data.Status === 0 && response.data.Data.length > 0) {
        setItmDrp(response.data.Data);

        if (InternalMode === "Add") {
          const selectedItem = response.data.Data[0];
          updateItemFields(selectedItem);
        }

      } else {
        setItmDrp([]);
        setValue("ItmId", "");
        setValue("Rate", 0);
        setValue("UnitId", "");
        setValue("Remk", "");

      }
    } catch (error) {
      toast.error('Error fetching items for the selected subgroup');
    }
  };
  const updateItemFields = (item) => {
    console.log("itemsss", item);
    setValue("ItmId", item.ItmId);
    setValue("Rate", item.CurrRate || 0);
    setValue("Remk", item.Remk || "");
    setValue("ItmCode", item.ItmCode || "");
    if (item.UnitId) {
      setValue("UnitId", item.UnitId);
    }

    if (item.ItmCatId) {
      setValue("ItmCatId", item.ItmCatId);
      setCategorySelected(true);

      axiosInstance.post("MstItmGrp/GetMstItmGrpdrp", { ItmCatId: item.ItmCatId, Flag: "" })
        .then(groupResponse => {
          if (groupResponse.data.Status === 0) {
            setGroupDrp(groupResponse.data.Data);

            if (item.ItmGrpId) {
              setValue("ItmGrpId", item.ItmGrpId);
              axiosInstance.post("MstItmSubGrp/GetMstItmSubGrpdrp", { ItmGrpId: item.ItmGrpId, Flag: "" })
                .then(subGroupResponse => {
                  if (subGroupResponse.data.Status === 0) {
                    setSubGrpdrp(subGroupResponse.data.Data);

                    if (item.ItmSubGrpId) {
                      setValue("ItmSubGrpId", item.ItmSubGrpId);
                    }
                  }
                });
            }
          }
        });
    }
  };

  // Helper function to reset item-related fields
  const resetItemFields = () => {
    setValue("ItmId", "");
    setValue("Rate", 0);
    setValue("UnitId", "");
    setValue("Remark", "");
    setValue("ItmCatId", "");
    setValue("ItmGrpId", "");
    setValue("ItmSubGrpId", "");
    setCategorySelected(false);
  };

  const fetchGroupsForCategory = async (categoryId) => {
    try {
      const response = await axiosInstance.post(
        "MstItmGrp/GetMstItmGrpdrp",
        { ItmCatId: categoryId, Flag: "" }
      );
      if (response.data.Status === 0) {
        setGroupDrp(response.data.Data);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  const fetchSubGroupsForGroup = async (groupId) => {
    try {
      const response = await axiosInstance.post(
        "MstItmSubGrp/GetMstItmSubGrpdrp",
        { ItmGrpId: groupId, Flag: "" }
      );
      if (response.data.Status === 0) {
        setSubGrpdrp(response.data.Data);
      }
    } catch (error) {
      console.error("Error fetching subgroups:", error);
    }
  };


  const itemCategory = (e) => {
    const selectedItmId = e.target.value;
    setValue("ItmId", selectedItmId);
    const selectedItem = ItmDrp.find((item) => item.ItmId === selectedItmId);
    if (selectedItem) {
      setValue("Rate", selectedItem.CurrRate || 0);
      setValue("UnitId", selectedItem.UnitId || "");
      setValue("Remark", selectedItem.Remark || "");
    }
  };

  const handleClickAdd = () => {
    setInternalMode("Add");
    setAllTextDisabled(false);
    reset({ ItmCatId: "", ItmGrpId: "", ItmSubGrpId: "", ItmId: "", ItmQty: "", Rate: "0.00", ItmAmt: "0.00", UnitId: "", Remark: "", setSelectedProperty: '' });
    setIndexofSelect(-1);
    setAllButtonDisabled(true);
    setAddDisabled(true);
    setCategorySelected(false);
    fetchAllItems()
  };

  const handleClickEdit = () => {
    if (IndexofSelect >= 0) {
      setInternalMode("Edit");
      setAllTextDisabled(false);
      setAllButtonDisabled(true);
      setAddDisabled(true);
    }
  };

  const handleRowClick = (rowIndex) => {
    const selectedRow = TableData[rowIndex];
    console.log("selectedRow",)
    setIndexofSelect(rowIndex);
    setAllButtonDisabled(false);
    setAddDisabled(false);
    setAllTextDisabled(true);
    setCategorySelected(true);
    reset({
      ItmCatId: selectedRow.ItmCatId,
      ItmGrpId: selectedRow.ItmGrpId,
      ItmSubGrpId: selectedRow.ItmSubGrpId,
      ItmId: selectedRow.ItmId,
      ItmQty: selectedRow.ItmQty,
      Rate: selectedRow.Rate,
      TagId: selectedRow.TagId,
      ItmAmt: selectedRow.ItmAmt,
      UnitId: selectedRow.UnitId,
      Remk: selectedRow.Remk,
    });
    setGroupDrp(GroupDrp.filter(g => g.ItmCatId === selectedRow.ItmCatId));
    setSubGrpdrp(SubGrpdrp.filter(s => s.ItmGrpId === selectedRow.ItmGrpId));
    setItmDrp(ItmDrp.filter(i => i.ItmSubGrpId === selectedRow.ItmSubGrpId));
  };

  const handleUnitChange = (event) => {
    const { name, value } = event.target;
    setValue(name, value);
  }
  const getUnitValue = () => {
    const unitId = watch("UnitId");
    const found = Unitdrp?.find((u) => u.UnitId === unitId);
    console.log("found", found);
    if (!found) return "";
    return {
      Id: found.UnitId,
      Name: found.UnitName
    }
  }
  const handleClickConfirm = () => {
    const formData = watch();
    console.log("formData:", formData);
    const requiredFields = ["ItmCatId", "ItmGrpId", "ItmSubGrpId", "ItmId", "UnitId"];

    const currentUnitId = formData.UnitId || (Unitdrp.length > 0 ? Unitdrp[0].UnitId : "");
    if (requiredFields.some(field => {
      if (field === "UnitId") {
        return !currentUnitId;
      }
      return !formData[field];
    })) {
      toast.error("Please fill all required fields");
      return;
    }
    const quantity = parseFloat(formData.ItmQty);
    if (isNaN(quantity) || quantity <= 0) {
      toast.error("Quantity must be greater than zero");
      return;
    }
    // const selectedUnit = Unitdrp.find(unit => unit.UnitId === parseInt(formData.UnitId));
    const selectedItem = ItmDrp.find(item => item.ItmId === formData.ItmId);
    const selectedCategory = CategoryDrp.find(cat => cat.ItmCatId === formData.ItmCatId);
    const selectedGroup = GroupDrp.find(grp => grp.ItmGrpId === formData.ItmGrpId);
    const selectedSubGroup = SubGrpdrp.find(sub => sub.ItmSubGrpId === formData.ItmSubGrpId);
    const selectedUnit = Unitdrp.find(unit => unit.UnitId === parseInt(formData.UnitId));
    const unitName = selectedUnit ? selectedUnit.UnitName : "";
    console.log('selevctedunit', selectedUnit?.UnitName)
    const newItem = {
      ...formData,
      IsuDtlId: InternalMode === "Edit" && TableData[IndexofSelect]?.IsuDtlId ? TableData[IndexofSelect].IsuDtlId : 0,

      ItmCat: selectedCategory,
      ItmGrp: selectedGroup,
      ItmSubGrp: selectedSubGroup,
      Itm: selectedItem,
      Unit: selectedUnit,
      ItmCatName: CategoryDrp.find(c => c.ItmCatId === formData.ItmCatId)?.ItmCatName || "",
      UnitName: selectedUnit?.UnitName || "",
      ItmGrpName: GroupDrp.find(g => g.ItmGrpId === formData.ItmGrpId)?.ItmGrpName || "",
      ItmSubGrpName: SubGrpdrp.find(s => s.ItmSubGrpId === formData.ItmSubGrpId)?.ItmSubGrpName || "",
      ItmName: ItmDrp.find(i => i.ItmId === formData.ItmId)?.ItmName || "",
      // ItmQty: parseFloat(formData.ItmQty) || 0,
      TagId: formData.TagId || 1,
      ItmQty: quantity,
      Rate: parseFloat(formData.Rate) || 0,
      ItmAmt: parseFloat(formData.ItmAmt) || 0,
      UnitId: parseInt(formData.UnitId),
      DBFLAG: InternalMode === "Add" ? "I" : TableData[IndexofSelect]?.DBFLAG === "I" ? "I" : "U",
      Status: "1"
    };

    const safeTableData = Array.isArray(TableData) ? TableData : [];

    // if (InternalMode === "Add") {
    //   // if (!TableData.some(item => item?.ItmId === newItem?.ItmId && item?.DBFLAG !== "D")) {
    //     if (!(TableData ?? []).some(item => item?.ItmId === newItem?.ItmId && item?.DBFLAG !== "D")) {

    //     setTableData([...TableData, newItem]);
    //   } else {
    //     toast.error("Duplicate item detected");
    //     return;
    //   }
    // } 

    if (InternalMode === "Add") {
      const isDuplicate = safeTableData.some(
        item => item?.ItmId === newItem?.ItmId && item?.DBFLAG !== "D"
      );

      if (!isDuplicate) {
        setTableData([...safeTableData, newItem]);
      } else {
        toast.error("Duplicate item detected");
      }
    }
    else {
      const updatedTableData = [...TableData];
      updatedTableData[IndexofSelect] = newItem;
      setTableData(updatedTableData);
    }

    setAddDisabled(false);
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
    setIndexofSelect(TableData?.length > 0 ? 0 : -1);
    setValue("UnitId", formData.UnitId);
  };

  const handleClickCancel = () => {
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
    reset({ ItmCatId: "", ItmGrpId: "", ItmSubGrpId: "", ItmId: "", ItmQty: 1, Rate: "0.00", ItmAmt: "0.00", UnitId: "", Remk: "" });
    setIndexofSelect(TableData?.length > 0 ? 0 : -1);
    setAddDisabled(false);
  };

  const handleDelete = () => {
    if (IndexofSelect >= 0) setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    const updatedTableData = [...TableData];
    const itemFlag = updatedTableData[IndexofSelect].DBFLAG;
    if (itemFlag === "U" || itemFlag === "R") {
      updatedTableData[IndexofSelect].DBFLAG = "D";
    } else {
      updatedTableData.splice(IndexofSelect, 1);
    }
    setTableData(updatedTableData);
    setOpenDialog(false);
    setIndexofSelect(updatedTableData.length > 0 ? 0 : -1);
    setAllButtonDisabled(false);
    setAddDisabled(false);
    setAllTextDisabled(true);
  };

  const handleSubmit = async () => {
    if (!AllTextDisabled) {
      toast.info("Please confirm or cancel the current operation");
      return;
    }

    if (TableData.length === 0) {
      toast.error("Please add at least one item before submitting");
      return;
    }

    console.log("AllfieldStepperData step 2", AllfieldStepperData)

    TextDisabledFast(true);
    const totalAmount = TableData.reduce((sum, item) => sum + (parseFloat(item.ItmAmt) || 0), 0);
    const totalQuantity = TableData.reduce((sum, item) => sum + (parseFloat(item.ItmQty) || 0), 0);
    const payload = {
      DBFLAG: mode === "add" ? "I" : "U",
      IsuId: mode === "edit" ? IsuId : 0,
      IsuNo: AllfieldStepperData.IsuNo || `S${Date.now()}`,
      IsuDt: AllfieldStepperData.IsuDt || new Date().toISOString(),
      RefNo: AllfieldStepperData.RefNo || "",
      IsuType: AllfieldStepperData.IsuType || "Pur",
      PropId: AllfieldStepperData?.PropertyId,
      PartyId: AllfieldStepperData.PartyId,
      PartyDtlId: AllfieldStepperData.PartyDtlId,
      ShPartyId: AllfieldStepperData.ShPartyId,
      ShPartyDtlId: AllfieldStepperData.ShPartyDtlId,
      IsuFrmLocId: AllfieldStepperData.IsuFrmLocId || 1,
      CustodianId: AllfieldStepperData.IsuFrmLocId || 1,
      TagFlg: 1,
      BillNo: AllfieldStepperData.BillNo,
      BillDt: AllfieldStepperData.BillDt,
      IsuQty: AllfieldStepperData.IsuQty,
      Amount: totalAmount,
      RndOff: AllfieldStepperData.RndOff || 0.00,
      Remark: AllfieldStepperData.Remark || "",
      Status: "1",
        // Conditionally add CreatedBy or UpdatedBy based on the mode
        ...(mode === "add" ? { CreatedBy: parseInt(UserLoginId) } : {}),
        ...(mode === "edit" ? { UpdatedBy: parseInt(UserLoginId) } : {}),


      TrnIsuItmList: TableData.map(item => ({
        DBFLAG: mode === "add" ? "I" : "U",
        IsuDtlId: item.IsuDtlId || 0,
        IsuId: mode === "edit" ? IsuId : 0,
        AssetDtlId: item.AssetDtlId || 1,
        ItmId: parseInt(item.ItmId),
        TagId: item.TagId || 1,
        UnitId: parseInt(item.UnitId),
        ItmQty: item.ItmQty,
        BalQty: item.ItmQty,
        Rate: parseFloat(item.Rate) || 0,
        ItmAmt: item.ItmAmt,
        Status: "1",
        Remk: item.Remk

      }))
    };



    console.log("AllfieldStepperDataaaa:", AllfieldStepperData);
    console.log("Payload before sendingggg:", payload);
    let FormattedObj = JSON.stringify(payload).replace(/"/g, '\\"');
    FormattedObj = '"' + FormattedObj + '"';
    try {
      const response = await axiosInstance.post("TrnIsu/ManageTrnIsuItm", FormattedObj);
      if (response.data.Status === 0) {
        toast.success(response.data.Message || "Record saved successfully");
        if (mode === "edit") await UnLock(IsuId, "TrnIsu", "IsuId");
        fetchGoodsData(mode === "add" ? 1 : IsuId, mode === "add" ? "L" : "R");
        setActiveStep(0);
        viewModeDis();
      } else {
        toast.error(response.data.Message || "Submission failed");
      }
    } catch (error) {
      console.error("Submission error:", error.response?.data || error.message);
      toast.error("Error submitting data: " + (error.response?.data?.message || error.message));
    } finally {
      TextDisabledFast(false);
    }
  };
  const handlePreviousClick = () => {
    if (!AllTextDisabled) {
      toast.info("Please Confirm or Cancel the current operation");
      return;
    }
    if (mode !== "view") {
      addModeDis();
      setFlag(true);
    }
    setActiveStep(0);
  };
  const handleClickCancelButton = async () => {
    if (!AllTextDisabled) {
      toast.info("Please Confirm or Cancel the current operation");
      return;
    }
    if (mode === "edit" && IsuId !== -1) {
      await UnLock(IsuId, "TrnIsu", "IsuId");
    }
    fetchGoodsData(IsuId !== -1 ? IsuId : 1, IsuId !== -1 ? "R" : "L");
    setActiveStep(0);
    viewModeDis();
  };
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const response = await getRoomMasterdropdata({
          Flag: "",
          UserId: userId,
        });
        if (response?.data?.Status === 0) {
          const dropdownItems = response.data.Data.map((item) => ({
            id: item.PropId,
            name: item.Name,
          }));
          setPropoption(dropdownItems);
          if (dropdownItems.length > 0) {
            setSelectedProperty(dropdownItems[0]);
          }
        }
      } catch (error) {
        toast.error("Error fetching property data");
      }
    };

    fetchDropdownData();
  }, [userId]);
  const fetchAllItems = async (searchTerm = "") => {
    try {
      const response = await axiosInstance.post(
        'MstItm/GetMstItmdrp',
        {
          SearchTerm: searchTerm,
          Flag: 'All'
        }
      );
      if (response.data.Status === 0) {
        setItmDrp(response.data.Data);

      } else {
        setItmDrp([]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      toast.error('Error fetching items');
    }
  };

  return (
    <Grid container spacing={2} sx={{ paddingInline: '120px', margin: '0 80', maxWidth: '1200px' }}>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this record?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{ backgroundColor: '#635bff', color: 'white', '&:hover': { backgroundColor: '#1565c0' } }} onClick={handleConfirmDelete}>Yes</Button>
          <Button sx={{ backgroundColor: '#635bff', color: 'white', '&:hover': { backgroundColor: '#1565c0' } }} onClick={() => setOpenDialog(false)}>No</Button>
        </DialogActions>
      </Dialog>

      <Grid item xs={12}>
        <Paper sx={{ width: "96%", overflow: "hidden", margin: "0px 0px 0px 15px", border: "1px solid lightgray" }}>
          <TableContainer sx={{ maxHeight: 140, overflowY: 'auto' }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow sx={{ "& > th": { padding: "0px 10px" } }}>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                      <Typography variant="subtitle1" fontWeight="bold">{column.label}</Typography>
                      <TextField
                        variant="outlined"
                        size="small"
                        placeholder={`Search ${column.label}`}
                        value={columnFilters[column.id] || ""}
                        onChange={(e) => {
                          setColumnFilters({
                            ...columnFilters,
                            [column.id]: e.target.value
                          });
                        }}
                        sx={{

                          "& .MuiOutlinedInput-root": {
                            height: 23,
                            fontSize: '0.8rem',
                            paddingLeft: '2px',
                            width: '100px'
                          }
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filterTableData(TableData)?.map((row, index) => (
                  <TableRow hover key={index}
                    sx={{
                      "& > td": { padding: "2px 14px" },
                      cursor: "pointer",
                      backgroundColor: IndexofSelect === index ? '#e3f2fd' : 'inherit',
                      '&:hover': {
                        backgroundColor: IndexofSelect === index ? '#e3f2fd' : '#f5f5f5',
                      }
                    }}
                    onClick={() => handleRowClick(index)}>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align}>
                        {column.id === "Rate" ? (row.Rate !== undefined && row.Rate !== null ? row.Rate : "0.00") :
                          column.id === "ItmAmt" ? (row.ItmAmt !== undefined && row.ItmAmt !== null ? row.ItmAmt : "0.00") :
                            (row[column.id] || "N/A")}
                        {/* {row[column.id] || "N/A"} */}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>

      <Grid item xs={12} sx={{
        display: "flex",
        gap: "12px",
        alignItems: "center",
        marginTop: "0px",
        justifyContent: "flex-start",
        marginLeft: '15px',
      }}>
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleClickAdd}
          disabled={AddDisabled || IsButtonSubmit}
          sx={{
            backgroundColor: "#635bff",
            color: "white",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 500,
            padding: '2px 8px',
            minWidth: "50px",
            boxShadow: "0 2px 4px rgba(99, 91, 255, 0.2)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#4a42d1",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 8px rgba(99, 91, 255, 0.3)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "&.Mui-disabled": {
              backgroundColor: "#e0e0e0",
              color: "#a0a0a0"
            }
          }}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<EditIcon />}
          disabled={AllButtonDisabled || IsButtonSubmit}
          onClick={handleClickEdit}
          sx={{
            borderColor: "#635bff",
            color: "#635bff",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 500,
            padding: '2px 8px',
            minWidth: "50px",
            boxShadow: "none",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(99, 91, 255, 0.08)",
              borderColor: "#4a42d1",
              color: "#4a42d1",
              transform: "translateY(-1px)",
              boxShadow: "0 2px 4px rgba(99, 91, 255, 0.2)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "&.Mui-disabled": {
              borderColor: "#e0e0e0",
              color: "#a0a0a0"
            }
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          size="small"
          startIcon={<DeleteIcon />}
          disabled={AllButtonDisabled || IsButtonSubmit}
          onClick={handleDelete}
          sx={{
            backgroundColor: "#ff4444",
            color: "white",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 500,
            padding: '2px 8px',
            minWidth: "50px",
            boxShadow: "0 2px 4px rgba(255, 68, 68, 0.2)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#cc0000",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 8px rgba(255, 68, 68, 0.3)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "&.Mui-disabled": {
              backgroundColor: "#e0e0e0",
              color: "#a0a0a0"
            }
          }}
        >
          Delete
        </Button>
      </Grid>
      <Grid container spacing={2} sx={{
        width: "95%",
        margin: "8px auto 0",
        paddingInline: "14px",
        paddingBlock: '0px',
        backgroundColor: "white",
        borderRadius: "12px",
        boxShadow: "0 1px 5px rgba(0,0,0,0.08)"
      }}>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="column" gap={1}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  label="Item code"
                  name="Code"
                  type="text"
                  variant="filled"
                  className="custom-textfield"
                  size="small"
                  value={watch("ItmCode") || ""}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "background.paper"
                    }
                  }}
                  {...register("0")}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  label="Tag No."
                  name="TagId"
                  type="text"
                  variant="filled"
                  className="custom-textfield"
                  size="small"
                  value={watch("TagId") || ""}
                  onChange={handleTagIdChange}
                  disabled={AllTextDisabled}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "background.paper"
                    }
                  }}
                  {...register("TagId")}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  id="item-autocomplete"
                  options={ItmDrp}
                  getOptionLabel={(option) => option.ItmName}
                  value={ItmDrp.find(item => item.ItmId === watch('ItmId')) || null}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      updateItemFields(newValue);
                    } else {
                      resetItemFields();
                    }
                  }}
                  disabled={AllTextDisabled}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      className="custom-textfield"
                      placeholder="Search Item..."
                      label={
                        <>
                          Item Description
                          <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                        </>
                      }
                      size="small"

                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                        }
                      }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.ItmId === value.ItmId}
                  noOptionsText="No items available"
                />

              </Grid>


              <Grid item xs={12} md={2}>

                <CustomAutocomplete
                  id="Unit-autocomplete"
                  name="UnitId"
                  label={
                    <>
                      Unit
                      <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                    </>
                  }
                  // options={Unitdrp}
                  options={Unitdrp?.map(u => ({ Id: u.UnitId, Name: u.UnitName }))}
                  // value={Unitdrp.find(unit => unit.UnitId === watch('UnitId')) || ''}
                  value={getUnitValue()}
                  onChange={handleUnitChange}
                  // onChange={(e) => setValue("UnitId", e.target.value)}
                  disabled={AllTextDisabled}
                  sx={{ width: '100%' }}

                />
              </Grid>

            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="ItmCatId-select-label">
                    Category
                    <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="ItmCatId-select-label"
                    id="ItmCatId"
                    name="ItmCatId"
                    value={watch("ItmCatId") || ""}
                    onChange={handleCategoryChange}
                    disabled={AllTextDisabled}
                    label={
                      <>
                        Category
                        <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </>
                    }
                    sx={{
                      borderRadius: "8px",
                      backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                    }}
                  >
                    {CategoryDrp.map((type) => (
                      <MenuItem key={type.ItmCatId} value={type.ItmCatId}>{type.ItmCatName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <CustomAutocomplete
                                                    id="category-autocomplete"
                                                    name="ItmCatId"
                                                    label={
                                                        <>
                                                            Category
                                                            <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                                                        </>
                                                    }
                                                    options={CategoryDrp}
                                                    value={CategoryDrp.find(type => type.ItmCatId === watch("ItmCatId")) || null} // Set the selected value
                                                    onChange={(event, newValue) => {
                                                        handleCategoryChange(event, newValue);
                                                    }}
                                                    disabled={AllTextDisabled}
                                                    noOptionsText="No categories found"
                
                                                /> */}
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="ItmGrpId-name-select-label">
                    Group
                    <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="ItmGrpId-name-select-label"
                    id="ItmGrpId"
                    name="ItmGrpId"
                    value={watch("ItmGrpId") || ""}
                    onChange={handleGroupChange}
                    disabled={!categorySelected || AllTextDisabled}
                    label={
                      <>
                        Group
                        <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </>
                    }
                    sx={{
                      borderRadius: "8px",
                      backgroundColor: (!categorySelected || AllTextDisabled) ? "action.disabledBackground" : "background.paper"
                    }}
                  >
                    {GroupDrp.map((type) => (
                      <MenuItem key={type.ItmGrpId} value={type.ItmGrpId}>{type.ItmGrpName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <CustomAutocomplete
                                                    id="group-autocomplete"
                                                    name="ItmGrpId"
                                                    label={
                                                        <>
                                                            Group
                                                            <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                                                        </>
                                                    }
                                                    options={GroupDrp}
                                                    value={GroupDrp.find(type => type.ItmGrpId === watch("ItmGrpId")) || null}
                                                    onChange={handleInputChange}
                                                    disabled={!categorySelected || AllTextDisabled}
                                                    noOptionsText="No groups found"
                
                                                /> */}
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="ItmSubGrpId-select-label">
                    Sub Group
                    <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="ItmSubGrpId-select-label"
                    id="ItmSubGrpId"
                    name="ItmSubGrpId"
                    value={watch('ItmSubGrpId') || ""}
                    disabled={!categorySelected || AllTextDisabled}
                    {...register("ItmSubGrpId")}
                    onChange={handleSubGrpChange}
                    label={
                      <>
                        Sub Group
                        <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </>
                    }
                    sx={{
                      borderRadius: "8px",
                      backgroundColor: (!categorySelected || AllTextDisabled) ? "action.disabledBackground" : "background.paper"
                    }}
                  >
                    {SubGrpdrp.map((type) => (
                      <MenuItem key={type.ItmSubGrpId} value={type.ItmSubGrpId}>{type.ItmSubGrpName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <CustomAutocomplete
                                                    id="sub-group-autocomplete"
                                                    name="ItmSubGrpId"
                                                    label={
                                                        <>
                                                            Sub Group
                                                            <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                                                        </>
                                                    }
                                                    options={SubGrpdrp}
                                                    value={SubGrpdrp.find(type => type.ItmSubGrpId === watch('ItmSubGrpId')) || null}
                                                    onChange={handleInputChange}
                                                    disabled={!categorySelected || AllTextDisabled}
                                                    noOptionsText="No sub groups found"
                
                                                /> */}
              </Grid>
              <Grid item xs={12} md={1.5}>
                <TextField
                  fullWidth
                  label={
                    <span>
                      Quantity
                      <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  className="custom-textfield"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                    }
                  }}
                  {...register("ItmQty")}
                  value={watch("ItmQty")}
                  // onChange={(e) => setValue("ItmQty", e.target.value)}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || (!isNaN(value) && parseFloat(value) > 0)) {
                      setValue("ItmQty", value);
                    }
                  }}
                  error={parseFloat(watch("ItmQty")) <= 0}
                  helperText={parseFloat(watch("ItmQty")) <= 0 ? "ItmQty can't be zero" : ""}
                  disabled={AllTextDisabled}
                />
              </Grid>
              <Grid item xs={12} md={1.5}>
                <TextField
                  fullWidth
                  label="Rate"
                  variant="filled"
                  className="custom-textfield"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                    }
                  }}
                  {...register("Rate")}
                  value={watch("Rate") || "0.00"}
                  onChange={(e) => setValue("Rate", e.target.value)}
                  disabled={AllTextDisabled}

                />
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  label="Amount"
                  variant="filled"
                  className="custom-textfield"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "action.disabledBackground"
                    }
                  }}
                  {...register("ItmAmt")}
                  value={watch("ItmAmt") || "0.00"}
                  disabled
                />
              </Grid>

              <Grid item xs={12} md={2} sx={{ display: "flex", gap: "11px", alignItems: "center" }}>
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor: "#635bff",
                    color: "white",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: "500",
                    boxShadow: "none",
                    padding: '2px 8px',
                    "&:hover": {
                      backgroundColor: "#4a42d1",
                      boxShadow: "none"
                    }
                  }}
                  disabled={AllTextDisabled}
                  onClick={handleClickConfirm}
                >
                  Confirm
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    borderColor: "#635bff",
                    color: "#635bff",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: "500",
                    padding: '2px 8px',
                    "&:hover": {
                      borderColor: "#4a42d1",
                      color: "#4a42d1"
                    }
                  }}
                  disabled={AllTextDisabled}
                  onClick={handleClickCancel}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  label="Remark"
                  variant="filled"
                  className="custom-textfield"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                    }
                  }}
                  {...register("Remk")}
                  value={watch('Remk') || ''}
                  onChange={(e) => setValue("Remk", e.target.value)}
                  disabled={AllTextDisabled}

                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid item ref={divRef} xs={2} className="form_button" sx={{ display: "flex", gap: "10px", alignItems: "center", marginTop: "10px", marginLeft: "59vw", textAlign: "right" }}>
        {['Prev', 'Submit', 'Cancel'].map((label, index) => (
          <Button key={index} sx={{ background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)', width: "50px" }} variant="contained" onClick={label === 'Prev' ? handlePreviousClick : label === 'Submit' ? handleSubmit : handleClickCancelButton} disabled={IsButtonSubmit}>
            {label}
          </Button>
        ))}
      </Grid>

    </Grid>
  );
};

export default StoreStep2;